import { render, staticRenderFns } from "./InvoiceTransaction.vue?vue&type=template&id=310caecd&"
import script from "./InvoiceTransaction.vue?vue&type=script&lang=js&"
export * from "./InvoiceTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports